import React from 'react';
import { CURRENCIES_ARRAY } from '../util/currencies';
import { AutoComplete } from './shared/inputs';

interface CurrencyDropdownProps {
  currency: string;
  setCurrency: (currency: string) => void;
  label?: string;
}

export function CurrencyDropdown({ currency, setCurrency, label = 'Currency' }: CurrencyDropdownProps) {
  const currencyOptions = CURRENCIES_ARRAY.map((value) => ({ value: value.id, label: `${value.name} (${value.symbol})` }));

  return (
    <AutoComplete
      value={currency}
      options={currencyOptions}
      onChange={(value) => {
        if (currencyOptions.some((option) => option.value === value)) {
          setCurrency(value as string);
        }
      }}
      label={label}
    />
  );
}
